/**
 * section-faq-two-col.js
 * Accordion logic for the FAQ Two Column section.
 * Vanilla JS — multi-instance safe — one open at a time per accordion.
 */

(function () {
  'use strict';

  /* ── Slide helpers ────────────────────────────────────── */
  function slideOpen(el) {
    el.removeAttribute('hidden');
    el.style.height = '0';
    el.style.overflow = 'hidden';
    el.style.transition = 'height 0.28s ease';
    requestAnimationFrame(() => {
      el.style.height = el.scrollHeight + 'px';
    });
    el.addEventListener('transitionend', function handler() {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', handler);
    });
  }

  function slideClose(el, callback) {
    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
    el.style.transition = 'height 0.25s ease';
    requestAnimationFrame(() => {
      el.style.height = '0';
    });
    el.addEventListener('transitionend', function handler() {
      el.setAttribute('hidden', '');
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', handler);
      if (callback) callback();
    });
  }

  /* ── Init a single accordion ──────────────────────────── */
  function initAccordion(accordionEl) {
    const items = accordionEl.querySelectorAll('[data-faq2-item]');

    function closeItem(item) {
      const answer  = item.querySelector('[data-faq2-answer]');
      const trigger = item.querySelector('[data-faq2-trigger]');
      if (!answer || !item.classList.contains('is-open')) return;
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      slideClose(answer);
    }

    items.forEach(function (item) {
      const trigger = item.querySelector('[data-faq2-trigger]');
      const answer  = item.querySelector('[data-faq2-answer]');
      if (!trigger || !answer) return;

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        // Close all siblings
        items.forEach(function (other) {
          if (other !== item) closeItem(other);
        });

        // Toggle current
        if (isOpen) {
          closeItem(item);
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          slideOpen(answer);
        }
      });
    });
  }

  /* ── Init all instances on the page ──────────────────── */
  function init() {
    document.querySelectorAll('[data-faq2-accordion]').forEach(initAccordion);
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var accordion = e.target.querySelector('[data-faq2-accordion]');
    if (accordion) initAccordion(accordion);
  });

})();